import type { SupportTicketStatus } from '../types/supportTypes'

// How each ticket status reads in the Previous Requests list. The Figma shows
// a new ticket ("open" on the wire) as SUBMITTED.
export const SUPPORT_TICKET_STATUS_META: Record<
  SupportTicketStatus,
  { label: string; color: string }
> = {
  open: { label: 'Submitted', color: 'var(--p-success-700)' },
  in_progress: { label: 'In progress', color: 'var(--p-info-700)' },
  awaiting_user: { label: 'Awaiting your reply', color: 'var(--p-warning-700)' },
  resolved: { label: 'Resolved', color: 'var(--p-success-700)' },
  closed: { label: 'Closed', color: 'var(--p-text-muted-color)' },
}

// The list has no pagination in the design, so it asks for the server's
// maximum page. Sellers raise a handful of tickets, not hundreds.
export const SUPPORT_TICKETS_FETCH_LIMIT = 50

// Mirrors seller-service's validation, so the form stops the seller before the
// server has to.
export const SUPPORT_TICKET_SUBJECT_MAX_LENGTH = 200
export const SUPPORT_TICKET_DESCRIPTION_MAX_LENGTH = 5000
export const SUPPORT_TICKET_NAME_MAX_LENGTH = 100

// Types the attachment picker offers — the same set investors can attach — and
// seller-service's upload limit, checked here so an oversized file is caught
// before the request rather than as a generic server validation error.
export const SUPPORT_TICKET_ATTACHMENT_ACCEPT = 'application/pdf,image/jpeg,image/png'
export const SUPPORT_TICKET_ATTACHMENT_EXTENSIONS = ['.pdf', '.jpg', '.jpeg', '.png']
export const SUPPORT_TICKET_ATTACHMENT_MAX_MB = 10

// Ticket categories are reference data — they change with a release.
export const TICKET_CATEGORIES_STALE_MS = 1000 * 60 * 30

// "Report an issue" on Property details (FSD 3.3.2): a property-status ticket,
// filed under the seeded seller category of that code, 10–1,000 characters.
export const PROPERTY_ISSUE_CATEGORY_CODE = 'property_status'
export const PROPERTY_ISSUE_MIN_LENGTH = 10
export const PROPERTY_ISSUE_MAX_LENGTH = 1000
